import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AppService {

  private appTitle$ = new BehaviorSubject<string>('');

  constructor(
    private http: HttpClient
  ) { }

  public getTitle(): Observable<string> {
    return this.appTitle$;
  }

  private parentMenuData = new BehaviorSubject<any>({});
  currentParentMenuData = this.parentMenuData.asObservable();

  chageParentMenuData(data: any) {
    this.parentMenuData.next(data)
  }

  private childMenuData = new BehaviorSubject<any>({});
  currentChildMenuData = this.childMenuData.asObservable();

  chageChildMenuData(data: any) {
    this.childMenuData.next(data)
  }

  setTitle(title: string) {
    this.appTitle$.next(title);
  }

  epochToDate(data: number) {
    const date = new Date(data * 1000);
    return date.toLocaleDateString("en-US");
  }

  validateUser() {
    return this.http.get(`${environment.baseUrl}/user/v1/validate`);
  }

  saveUsers(data: any) {
    return this.http.post(`${environment.baseUrl}/user/v1/login/`, data);
  }

  listUserById(id: any) {
    return this.http.get(`${environment.baseUrl}/user/v1/get-user/${id}`);
  }
}
